module.exports = __webpack_public_path__ + "agency_logo.ea1b9bc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/LiveChat/logos/agency_logo.png
// module id = 2076
// module chunks = 0